export class ScoreDisplay {
    private container: HTMLDivElement;
    private scoreElement: HTMLDivElement;

    constructor() {
        // Create container
        this.container = document.createElement('div');
        this.container.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background-color: rgba(0, 0, 0, 0.7);
            padding: 10px 20px;
            border-radius: 10px;
            color: white;
            font-family: Arial, sans-serif;
            z-index: 1000;
            border: 2px solid #8A2BE2;
            box-shadow: 0 0 10px rgba(138, 43, 226, 0.5);
        `;

        // Create score display
        this.scoreElement = document.createElement('div');
        this.scoreElement.style.cssText = `
            font-size: 1.2em;
            font-weight: bold;
        `;
        this.scoreElement.textContent = 'Score: 0';

        // Add to container
        this.container.appendChild(this.scoreElement);

        // Add to document
        document.body.appendChild(this.container);
    }

    public updateScore(score: number) {
        this.scoreElement.textContent = `Score: ${score}`;
    }

    public show() {
        this.container.style.display = 'block';
    }

    public hide() {
        this.container.style.display = 'none';
    }

    public remove() {
        if (this.container.parentNode) {
            this.container.parentNode.removeChild(this.container);
        }
    }
} 